"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatting = void 0;
const create_fn_1 = require("../utils/create-fn");
const get_arg_1 = require("../utils/get-arg");
const unsupported_fn_1 = require("../utils/unsupported-fn");
// https://gitlab.icg360.net/eng/pxserver/-/blob/master/src/main/java/com/ics360/expressions/functions/Formatting.java#L61-65
const numberformat = (0, unsupported_fn_1.unsupportedFn)("fn.formatting.numberformat");
// possibly use https://github.com/leemotive/decimal-format
const currencyformat = (0, unsupported_fn_1.unsupportedFn)("fn.formatting.currencyformat");
const topropercase = (0, unsupported_fn_1.unsupportedFn)("fn.formatting.topropercase");
/*
## fn.formatting.touppercase

Converts a string to uppercase.

### Arguments

1. (string) The string to convert to uppercase.

Returns the string in uppercase. (string)
*/
const touppercase = (0, create_fn_1.createFn)("fn.formatting.touppercase", (args, context) => {
    const value = (0, get_arg_1.getArgString)(args, 1, context);
    return value.toUpperCase();
});
/*
## fn.formatting.tolowercase

Converts a string to lowercase.

### Arguments

1. (string) The string to convert to lowercase.

Returns the string in lowercase. (string)
*/
const tolowercase = (0, create_fn_1.createFn)("fn.formatting.tolowercase", (args, context) => {
    const value = (0, get_arg_1.getArgString)(args, 1, context);
    return value.toLowerCase();
});
/*
## fn.formatting.toordinal

Converts a number to an ordinal number.

### Arguments

1. (number) The number to convert to an ordinal number.

Returns the ordinal number. (string)

### Example

```
fn.formatting.toordinal(1) // "1st"
fn.formatting.toordinal(2) // "2nd"
fn.formatting.toordinal(3) // "3rd"
```
*/
const englishOrdinalRules = new Intl.PluralRules("en", { type: "ordinal" });
const toordinal = (0, create_fn_1.createFn)("fn.formatting.toordinal", (args, context) => {
    const value = (0, get_arg_1.getArgNumber)(args, 1, context);
    const category = englishOrdinalRules.select(value);
    switch (category) {
        case "one": {
            return `${value}st`;
        }
        case "two": {
            return `${value}nd`;
        }
        case "few": {
            return `${value}rd`;
        }
        default: {
            return `${value}th`;
        }
    }
});
exports.formatting = {
    numberformat,
    currencyformat,
    touppercase,
    tolowercase,
    topropercase,
    toordinal,
};
//# sourceMappingURL=formatting.js.map